import { getBrowserApiBaseUrl } from '@/config/env'
import { getAuthToken } from '@/lib/api/apiClient'

/** Angular `downloadClaimAffidavit` — `/api/skip_claim_affidavit/{applicationId}` with token + optional claim id. */
export function buildSkipAffidavitPortalUrl(
  applicationId: string | number,
  reimbursementId?: string | number | null,
): string {
  const params = new URLSearchParams()
  const token = getAuthToken()
  if (token) params.set('access_token', token)
  if (reimbursementId != null && String(reimbursementId).trim() !== '') {
    params.set('reimbursement_id', String(reimbursementId))
  }
  const query = params.toString()
  const base = `${getBrowserApiBaseUrl()}/api/skip_claim_affidavit/${applicationId}`
  return query ? `${base}?${query}` : base
}
